module.exports = __webpack_public_path__ + "img/icon_dashboard_user_day.4e3c55a.svg";